import { twMerge } from "tailwind-merge";
import type { VesselDataField } from "../models/vessel-data.models";

const displayValue = (value: VesselDataField["value"]): string => {
  if (value === null || value === "") {
    return "—";
  }

  if (typeof value === "boolean") {
    return value ? "True" : "False";
  }

  return String(value);
};

// Renders source-nullable Power BI cards without replacing missing source values with fabricated defaults.
const VesselDataFieldGrid = ({ fields }: { fields: VesselDataField[] }) => (
  <dl className="grid grid-cols-2 gap-3 p-4 md:grid-cols-3 xl:grid-cols-6">
    {fields.map((field) => (
      <div key={field.label} className={twMerge("min-w-0 rounded-lg bg-gray-50 px-3 py-3 dark:bg-gray-900/50", field.wide && "md:col-span-2")}>
        <dt className="text-[10px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">{field.label}</dt>
        <dd className={twMerge("mt-1.5 break-words text-xs font-semibold", field.value === null ? "text-gray-400" : "text-gray-800 dark:text-gray-100")}>{displayValue(field.value)}</dd>
      </div>
    ))}
  </dl>
);

export default VesselDataFieldGrid;
